export const EligibilityCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: (el, s) => s.expired ? '2px solid red' : '2px solid green',

  state: { expired: false },

  HeaderRow: {
    flow: 'x',
    align: 'center flex-start',
    justifyContent: 'space-between',
    InsuranceName: { text: (el, s) => s.insuranceName || '', fontSize: 'A', fontWeight: '700', color: 'inkText' },
    ActiveBadge: {
      tag: 'span',
      text: (el, s) => s.expired ? 'Expired' : 'Active',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => s.expired ? 'red.15' : 'green.15',
      color: (el, s) => s.expired ? 'red' : 'green'
    }
  },

  PolicyRow: {
    flow: 'x',
    gap: 'A',
    PolicyNumber: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ policyNumber | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.policyNumber || '', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
    },
    PlanType: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ planType | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.planType || '', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
    }
  },

  Divider: { height: '1px', background: 'inkBorder' },

  BenefitsRow: {
    flow: 'x',
    gap: 'A',
    AnnualMax: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ annualMax | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.annualMax || '', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
    },
    AnnualUsed: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ used | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.annualUsed || '', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
    },
    Remaining: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ remaining | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.remaining || '', fontSize: 'B', fontWeight: '700', color: 'teal' }
    }
  },

  DeductibleMet: {
    tag: 'span',
    text: (el, s) => s.deductibleMet ? 'Deductible Met' : 'Deductible Not Met',
    fontSize: 'Y',
    fontWeight: '600',
    padding: 'X Z',
    round: 'B',
    alignSelf: 'flex-start',
    background: (el, s) => s.deductibleMet ? 'green.15' : 'amber.15',
    color: (el, s) => s.deductibleMet ? 'green' : 'amber'
  },

  Divider2: { height: '1px', background: 'inkBorder' },

  CoverageTitle: { text: '{{ coverageByCategory | polyglot }}', fontSize: 'Y', fontWeight: '700', color: 'inkSubtle', textTransform: 'uppercase', letterSpacing: 'X' },

  CoverageGrid: {
    flow: 'y',
    gap: 'Y',
    Preventive: {
      flow: 'x',
      justifyContent: 'space-between',
      Label: { text: '{{ preventive | polyglot }}', fontSize: 'Z', color: 'inkText' },
      Value: { text: '100%', fontSize: 'Z', fontWeight: '700', color: 'green' }
    },
    Basic: {
      flow: 'x',
      justifyContent: 'space-between',
      Label: { text: '{{ basic | polyglot }}', fontSize: 'Z', color: 'inkText' },
      Value: { text: '80%', fontSize: 'Z', fontWeight: '700', color: 'teal' }
    },
    Major: {
      flow: 'x',
      justifyContent: 'space-between',
      Label: { text: '{{ major | polyglot }}', fontSize: 'Z', color: 'inkText' },
      Value: { text: '50%', fontSize: 'Z', fontWeight: '700', color: 'amber' }
    },
    Ortho: {
      flow: 'x',
      justifyContent: 'space-between',
      Label: { text: '{{ ortho | polyglot }}', fontSize: 'Z', color: 'inkText' },
      Value: { text: '50%', fontSize: 'Z', fontWeight: '700', color: 'amber' }
    }
  },

  VerifiedDate: { text: (el, s) => s.verifiedDate ? `Verified: ${s.verifiedDate}` : '', fontSize: 'Y', color: 'inkMuted', fontStyle: 'italic' }
}
